import React from "react";
import { useIntl } from "react-intl";

import { AppBar, Tab, Tabs } from "@material-ui/core";
import { a11yProps, TabPanel, useStyles } from "../../custom/Tabs";
import { TRDTab } from "./trd/TRDTab";
import { VersionTab } from "./version/VersionTab";
import { ProductionOfficeTab } from "./productionOffice/ProductionOfficeTab";
import { SeriesTab } from "./series/SeriesTab";
import { SubseriesTab } from "./subseries/SubseriesTab";
import { DocumentaryTypeTab } from "./documentaryType/DocumentaryTypeTab";

export const TRDTabsPanel = () => {
  const classes = useStyles();
  const intl = useIntl();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          className={classes.tabs}
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#0A8FDC",
            },
          }}
        >
          <Tab className={classes.tab} label="TRD" {...a11yProps(0)} />
          <Tab
            className={classes.tab}
            label={`${intl.formatMessage({ id: "Version" }).toUpperCase()}`}
            {...a11yProps(1)}
          />
          <Tab
            className={classes.tab}
            label={`${intl
              .formatMessage({ id: "ProductionOffice" })
              .toUpperCase()}`}
            {...a11yProps(2)}
          />
          <Tab
            className={classes.tab}
            label={`${intl.formatMessage({ id: "Series" }).toUpperCase()}`}
            {...a11yProps(3)}
          />
          <Tab
            className={classes.tab}
            label={`${intl.formatMessage({ id: "Subseries" }).toUpperCase()}`}
            {...a11yProps(4)}
          />
          <Tab
            className={classes.tab}
            label={`${intl
              .formatMessage({ id: "DocumentaryType" })
              .toUpperCase()}`}
            {...a11yProps(5)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <TRDTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <VersionTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ProductionOfficeTab />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <SeriesTab />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <SubseriesTab />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <DocumentaryTypeTab />
      </TabPanel>
    </div>
  );
};
